// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"tabsWrapper--lweU7","linearProgress":"linearProgress--SF1ox"};